import { View, ViewConstructor } from "../../../../core/view/index";
import { ScannedItemView } from "./scanned_item";
import { Template } from "../../../../core/template";
import { ClientAction } from "../../../synchronizer/index";
import { emptyElement } from "../../../../core/helpers/dom";


export class ScanPackagesView extends View {

    template = Template.lazy('/app/views/package_tracking/scan_packages/index.html');

    // A Hash to next view
    nextViewHash: string;

    // Class for subviews
    itemViewClass: ViewConstructor;

    resultsList: HTMLOListElement;
    codeInput: HTMLInputElement;
    nextButton: HTMLButtonElement;

    resultRows: ScannedItemView[] = [];

    public afterRender(): PromiseLike<any>
    {
        this.codeInput.focus();
        // Render initial items
        return super.afterRender().then(() => {
            if (this.data.items) {
                return Promise.all(this.data.items.map(item =>
                    this.renderScanned(new this.itemViewClass(item) as ScannedItemView)))
            }
            return;
        });
    }

    protected focusInputForScanner() {
        this.codeInput.readOnly = true;
        this.codeInput.focus();
        setTimeout(() => {
            this.codeInput.readOnly = false;
        });
    }

    /**
     * Called when then barcode form is submitted
     * @param e Submit event
     */
    public onScanFormSubmit(e: Event)
    {
        e.preventDefault();
        let tag = this.codeInput.value.trim();

        if (tag.length) {
            this.onCodeScanned(this.codeInput.value);
        }
    }

    protected clearResults()
    {
        emptyElement(this.resultsList);
    }

    /**
     * Called for a newly scanned item barcode / qr-code
     * @param tag Barcode / QR Code
     */
    protected onCodeScanned(tag: string)
    {
        // Clear previously scanned rows before adding new ones
        this.clearResults();

        this.app.api.private('pt_delivery_note_item_tags', {package_tag: tag}).then((items) => {
            if (items.length > 0) {
                items.forEach( (tag) => {
                    let scannedItem = new this.itemViewClass({fetch_tag: tag}) as ScannedItemView;
                    this.renderScanned(scannedItem);
                });
                this.nextButton.disabled = false;
            } else {
                this.app.toasts.show(this.pgettext('Message', 'Delivery note not found!'));
            }
        });
    }

    /**
     * Called when a new item needs to be rendered
     * @param scannedItem Item to render
     */
    protected renderScanned(scannedItem: ScannedItemView)
    {
        this.app.renderPartialView(scannedItem).then(() => {
            this.resultRows.push(scannedItem);
            this.resultsList.insertAdjacentElement('afterbegin', scannedItem.element);
        });
    }

    /**
     * Collect valid / non-empty items in a list when user want's to proceed to next page
     * @param e
     */
    protected onContinueButtonClick(e: MouseEvent)
    {
        e.preventDefault();

        // Collect all valid items
        this.data.items = this.resultRows.reduce((res, row, index) => {
            if (row.item) {
                res.push(row.item);
            }
            return res;
        }, []);

        this.onContinue(this.data.items);
    }

    /**
     * Called when user want's to proceed to next page and valid items has been collected
     * @param items Valid / Non-empty items
     */
    protected onContinue(items: any[]) {
        console.warn('ScanPackages.onContinue not implemented');
    }

}